"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DocumentIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "21",
  height: "25",
  viewBox: "0 0 21 25",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-192.000000, -125.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(194.000000, 127.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(-1.307692, -1.235294)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M2.61538462,8.64705882 L2.61538462,21 L17,21 L17,2.47058824 L9.04123932,2.47058824 L9.04123932,7.41176471 C9.04123932,8.0452678 8.53641753,8.5673912 7.88605156,8.6387481 L7.73354701,8.64705882 L2.61538462,8.64705882 Z M3.5103098,6.17647059 L6.42469231,6.17647059 L6.42537668,3.26729145 L3.5103098,6.17647059 Z M18.3076923,0 C19.0299108,0 19.6153846,0.553060015 19.6153846,1.23529412 L19.6153846,22.2352941 C19.6153846,22.9175282 19.0299108,23.4705882 18.3076923,23.4705882 L1.30769231,23.4705882 C0.585473789,23.4705882 0,22.9175282 0,22.2352941 L0,6.57892847 C0,6.26309016 0.128067532,5.95924839 0.357882818,5.72984716 L5.7111621,0.386212809 C5.95814701,0.139672881 6.3016432,0 6.66097159,0 L18.3076923,0 Z",
            fillRule: "nonzero"
          })
        })
      })
    })
  })]
});

DocumentIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = DocumentIcon;
exports.default = _default;